import { AbstractHistogram } from 'hdr-histogram-js'
import { ServiceReport } from './ServiceReport'

export interface EnvironmentReport<HISTOGRAM> {
    environment: string
    day: string
    serviceReports: { [key: string]: ServiceReport<HISTOGRAM> }
}

export const mergeEnvironmentReports = (reports: Array<EnvironmentReport<AbstractHistogram>>): EnvironmentReport<AbstractHistogram> => {
    const [first, ...rest] = reports

    // @todo make sure all reports have identical day + environment

    rest.map(report => {
        // we do not aggregate ServiceReports here - those need to be replaced
        first.serviceReports = {
            ...first.serviceReports,
            ...report.serviceReports,
        }
    })

    return first
}
